import { atom } from 'recoil';

export const CarrierModuleOpen = atom<boolean>({
	key: 'CarrierModuleOpen',
	default: false,
});

export const EfficiencyModuleOpen = atom<boolean>({
	key: 'EfficiencyModuleOpen',
	default: false,
});

export const ActiveModuleId = atom<string | null>({
	key: 'ActiveModuleId',
	default: null,
});

/** Ordered list of minimised module IDs — position in array determines dock slot. */
export const MinimisedModules = atom<string[]>({
	key: 'MinimisedModules',
	default: [],
});

/** Flat list of all shipment refs currently grouped in the Efficiency Recommendation results. */
export const EfficiencyRefs = atom<string[]>({
	key: 'EfficiencyRefs',
	default: [],
});

/**
 * When set to a shipment ref, the Efficiency Recommendation panel will open, auto-run if needed,
 * and pre-populate its search field with this ref. Cleared after consumption.
 */
export const EfficiencyFocusRef = atom<string | null>({
	key: 'EfficiencyFocusRef',
	default: null,
});
